import * as ActionLogin from '../../action/Login';
import * as actionComplaint from '../../action/Complaint/ActionComplaint';
import * as toggle from '../../action/toggle/index';

import {
    call,
    put,
    select,
    takeLatest
} from 'redux-saga/effects';

import { message } from 'antd';
import axios from 'axios';
import { downloadBlob } from '../../../lib/utils';

export function* S_detailComplaint(action:any)
{
    const state = yield select()
        const idComplaint = state.Complaint.detailComplaint.detail;
        const token = state.Auth.Token
        const config ={
            Authorization: `bearer ${token}`,
            'Content-type': 'application/json',
        }
    try
    {
        yield put(toggle.changeLoadingTrue())
        const {data} = yield call(
            axios.get,process.env.REACT_APP_URL+'/Portal/GetDataDetailComplaint/'+idComplaint,
            {headers:config}
        )
        yield put(actionComplaint.changeDetailD(data))
        yield put(actionComplaint.changeCodeTicketD(data?.tiket))
        yield put(actionComplaint.changeStatusD(data?.complaintType))
        yield put(actionComplaint.changePhoneNumberD(data?.shipToPhoneAccount))
        yield put(actionComplaint.changeTitleComplaintD(data?.question))
        yield put(actionComplaint.changeHistoryD(data?.history))
        yield put(toggle.changeLoadingFalse())
    } catch (error) {
        if (error.response.status === 401) {
            yield put(ActionLogin.submitTokenRefresh());
            yield put(toggle.changeLoadingFalse());
          }
          yield put(toggle.changeLoadingFalse());
    }
}

export function* S_downloadInvestigasiPdf()
{
    const state = yield select();
    const idComplaint = state.Complaint.detailComplaint.idComplaint;
    const codeTicket = state.Complaint.detailComplaint.codeTicket;
    const token = state.Auth.Token;
    const config = {
        Authorization: `bearer ${token}`,
        'Content-type': 'application/json',
    };

    if (!idComplaint) {
        message.error('ID complaint tidak ditemukan');
        return;
    }

    try {
        yield put(toggle.changeLoadingTrue());
        const response = yield call(
            axios.post,
            process.env.REACT_APP_URL + '/Complaint/DownloadInvestigasiPdf',
            { id: idComplaint },
            {
                headers: config,
                responseType: 'blob',
            }
        );
        downloadBlob(
            response.data,
            codeTicket ? `Investigasi_${codeTicket}` : `Investigasi_${idComplaint}`
        );
        message.success('Download berhasil');
    } catch (error) {
        if (error.response && error.response.status === 401) {
            yield put(ActionLogin.submitTokenRefresh());
        } else {
            message.error('Download gagal');
        }
    } finally {
        yield put(toggle.changeLoadingFalse());
    }
}

export function* SM_detailComplaint()
{
    yield takeLatest("SUBMIT_DETAIL_COMPLAINT", S_detailComplaint)
}

export function* SM_downloadInvestigasiPdf()
{
    yield takeLatest("DOWNLOAD_INVESTIGASI_PDF", S_downloadInvestigasiPdf)
}
